import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MenuItemCard = ({ item }) => {
  return (
    <div className="bg-card rounded-xl overflow-hidden shadow-warm hover:shadow-warm-lg transition-all duration-300 group">
      <div className="relative h-64 overflow-hidden">
        <Image
          src={item?.image}
          alt={item?.imageAlt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        {item?.isNew && (
          <div className="absolute top-4 right-4 bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1">
            <Icon name="Sparkles" size={14} />
            New
          </div>
        )}
        {item?.isSeasonal && (
          <div className="absolute top-4 left-4 bg-warning text-warning-foreground px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1">
            <Icon name="Leaf" size={14} />
            Seasonal
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
          <div className="flex items-center gap-2 text-white">
            <Icon name="Clock" size={16} />
            <span className="text-sm">{item?.prepTime}</span>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-start justify-between mb-2">
          <h3 className="font-serif text-xl font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
            {item?.name}
          </h3>
          <span className="text-lg font-semibold text-primary whitespace-nowrap ml-2">
            ${item?.price?.toFixed(2)}
          </span>
        </div>

        {item?.italianName && (
          <p className="text-sm text-muted-foreground italic mb-2">
            {item?.italianName}
          </p>
        )}

        <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
          {item?.description}
        </p>

        <div className="flex flex-wrap gap-2 mb-4">
          {item?.dietary?.map((diet, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-muted rounded-md text-xs font-medium text-foreground flex items-center gap-1"
            >
              <Icon name={diet?.icon} size={12} />
              {diet?.label}
            </span>
          ))}
        </div>

        {item?.ingredients && (
          <div className="mb-4">
            <p className="text-xs text-muted-foreground mb-2 flex items-center gap-1">
              <Icon name="Wheat" size={12} />
              Key Ingredients:
            </p>
            <p className="text-sm text-foreground">{item?.ingredients}</p>
          </div>
        )}

        {item?.story && (
          <div className="mb-4 p-3 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground mb-1 flex items-center gap-1">
              <Icon name="BookOpen" size={12} />
              Heritage Story:
            </p>
            <p className="text-sm text-foreground italic">{item?.story}</p>
          </div>
        )}

        <Button variant="default" fullWidth iconName="ShoppingBag" iconPosition="left">
          Add to Order
        </Button>
      </div>
    </div>
  );
};

export default MenuItemCard;